import { formatXP } from '@/lib/gamification';

interface Props {
  xp: number;
  size?: 'sm' | 'md';
}

export function XPBadge({ xp, size = 'md' }: Props) {
  return (
    <span
      className={[
        'inline-flex items-center gap-1 rounded-full font-semibold',
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs',
      ].join(' ')}
      style={{
        background: 'rgba(91, 79, 232, 0.15)',
        color: '#5B4FE8',
        border: '1px solid rgba(91, 79, 232, 0.3)',
      }}
      title={`${xp} XP`}
    >
      <span aria-hidden="true">⚡</span>
      {formatXP(xp)} XP
    </span>
  );
}
